import React, { useState } from "react";

const CardLayer = ({ cardString, onFold }) => {
  const [isFolded, setIsFolded] = useState(false);

  if (!cardString) {
    return null;
  }

  const handleXClick = () => {
    setIsFolded(true);
    if (onFold) {
      onFold();
    }
  };

  const handleCardClick = () => {
    if (isFolded) {
      setIsFolded(false);
    }
  };

  return (
    <div
      className="card-layer"
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 0, // Remove padding to fill entire screen
        boxSizing: "border-box",
        backgroundColor: isFolded ? "transparent" : "rgba(0, 0, 0, 0.3)",
        transition: "background-color 0.3s ease",
        pointerEvents: isFolded ? "none" : "auto",
      }}
    >
      <img
        src={`/images/cards/${cardString}`}
        alt="Card"
        onClick={handleCardClick}
        onLoad={(e) => {
          // Card image loaded successfully
        }}
        onError={(e) => {
          console.error('Failed to load card image:', cardString);
          console.error('Image path attempted:', `/images/cards/${cardString}`);
          console.error('Device info:', {
            userAgent: navigator.userAgent,
            screenWidth: window.screen.width,
            screenHeight: window.screen.height,
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight
          });
          e.target.style.display = 'none';
        }}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain", // Change back to "contain" to show full card without cropping
          cursor: isFolded ? "pointer" : "default",
          transform: isFolded ? "translateY(66.67%)" : "translateY(0)",
          transition: "transform 0.3s ease",
          pointerEvents: "auto",
        }}
      />
      {!isFolded && (
        <button
          onClick={handleXClick}
          style={{
            position: "fixed",
            bottom: "calc(var(--safe-area-bottom) + 32px)",
            left: "50%",
            transform: "translateX(-50%)",
            width: 56,
            height: 56,
            borderRadius: "50%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            color: "white",
            border: "2px solid rgba(255,255,255,0.4)",
            fontSize: "22px",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1001,
          }}
        >
          ✕
        </button>
      )}
    </div>
  );
};

export default CardLayer;
